import baseRequest from "../_core/baseRequest";

export default {
    getShiftSuggestionList: params => baseRequest.post("/shifts/suggestion/list", params),
    downloadShiftExcelFileFromSuggestions: params =>
        baseRequest.post("/shifts/suggestion/export", params, true),
    deleteShiftSuggestion: params => baseRequest.post(`/shifts/suggestion/delete`, params),
    approvePreference: params => baseRequest.put(`/shifts/suggestion/preference/approve`, params),
    rejectPreference: params => baseRequest.put(`/shifts/suggestion/preference/reject`, params),
    revertPreference: params => baseRequest.put(`/shifts/suggestion/preference/revert`, params),
    sendPreferenceNotification: params =>
        baseRequest.post(`/shifts/suggestion/send-preference-notification`, params),
    getCouriersToChooseShifts: params =>
        baseRequest.get(`/shifts/suggestion/get-couriers-to-choose-shifts/${params.date}`, params),
    openPreferences: params => baseRequest.post(`/shifts/suggestion/open-preferences`, params),
    resolvePreferences: params => baseRequest.post(`/shifts/suggestion/resolve-preferences`, params)
};
